import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const SignInComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "SignInPage" */ "@circle-react/components/OnboardingPage/SignInPage"
    ),
);

export const SignInPage = () => (
  <Suspense fallback={<PageLoader />}>
    <SignInComponent />
  </Suspense>
);
